import { call, put, select } from 'redux-saga/effects';
import {
  editOrganisationsFailure,
  fetchOrganisationsRequest,
} from '../actions';
import { editOrganisation } from '../api';
import { ApiError, ApiResponse } from 'store/api/types';

import { checkResponse } from 'store/utils';
import { EditOrganisationParams } from '../models';
import { EditOrganisationRequestAction } from '../types';
import { MessageData } from 'store/app/types';
import { turnMessageOn } from 'store/app/actions';
import { logoutRequest } from 'store/auth/actions';
import { renderErrorMessage } from 'utils/render-error-message';
import { MessageStates } from 'containers/MessageBox';
import i18n from 'i18next';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* editOrganisationsSaga(action: EditOrganisationRequestAction) {
  try {
    let err: ApiError | null;
    const params: EditOrganisationParams = action.payload.editOrganisation;
    //const fromVATChecker = action.payload.fromVATChecker || false;
    const editResponse: ApiResponse = yield call(editOrganisation, params);

    err = checkResponse(editResponse?.responseMessage);
    if (err) throw err;

    const message: MessageData = {
      title: i18n.t('common.success'),
      description: i18n.t('notifications.organisation-details-updated-successfully'),
      //description: editResponse.responseMessage.message,
      type: MessageStates.SUCCESS,
    };
    yield put(turnMessageOn(message));
    yield put(fetchOrganisationsRequest());
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(editOrganisationsFailure());
  }
}
